module.exports = __webpack_public_path__ + "img/user-icon.f4e98b37.svg";